module.exports = __webpack_public_path__ + "static/t1-9080568e8f8b8f0dfc84f1a8114fb330.png";